var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 683,
    height: 683,
    viewBox: "0 0 683 683",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.233 223.315C184.69 226.361 179.395 231.801 176.639 239.272C175.115 243.334 175.115 243.407 175.261 342.125L175.478 440.915L177.437 445.049C180.12 450.78 184.545 455.349 190.275 458.178L195.062 460.499H341.217H487.372L492.159 458.178C497.889 455.349 502.313 450.78 504.997 445.049L506.956 440.915V341.182V241.448L504.634 236.661C501.806 230.931 497.236 226.506 491.506 223.823L487.372 221.864L341.942 221.719L196.513 221.502L192.233 223.315ZM483.237 245.583C483.89 246.236 484.108 252.764 484.108 270.607V294.76H341.217H198.326V270.607C198.326 252.764 198.544 246.236 199.197 245.583C200.43 244.35 482.004 244.35 483.237 245.583ZM484.108 388.546C484.108 424.45 483.89 436.128 483.237 436.781C482.004 438.014 200.43 438.014 199.197 436.781C198.544 436.128 198.326 424.45 198.326 388.546V341.182H341.217H484.108V388.546Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.a46b661027550c227a5d2dcfad21be27.svg";
export { ForwardRef as ReactComponent };